'use client'

import { useEffect } from 'react'
import ErrorState from '../components/ErrorState'

interface ErrorPageProps {
    error: Error & { digest?: string }
    reset: () => void
}

export default function ErrorPage({ error, reset }: ErrorPageProps) {
    useEffect(() => {
        console.error(error)
    }, [error])

    return <ErrorState digest={error.digest} reset={reset} />
}
